module.exports = __webpack_public_path__ + "back-icon-8082f2140c8d75c50778.svg";